export default __webpack_public_path__ + "static/media/user.b99d5b09.svg";